import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "./ContactSection.css";
import ContactImage from "../../assets/Contact-graphics.png";
import { motion as MotionDiv } from "framer-motion";
import FloatingDots from "../FloatingDots"; 

export default function ContactSection() {
  return (
    <section className="csec-wrapper">
      {/* Left side image */}
      <div className="csec-image">
         <FloatingDots />
        <img
          src={ContactImage}
          alt="Contact Illustration"
          className="csec-img"
        />
      </div>

      {/* Right side content */}
      <div className="csec-content">
  <p className="csec-subtitle">Contact Us</p>
  <h2 className="csec-title">
  Let’s <span className="highlight">Connect</span>
</h2>
  <p className="csec-text">
    At <strong>Sreenathji Enterprises</strong>, we are committed to building
    long-lasting partnerships. Reach out to us for inquiries, collaborations,
    or more information about our products and services.
  </p>

  <div className="csec-info">
    {/* Visit Us */}
    <div className="csec-item">
      <div className="csec-icon">
        <FaMapMarkerAlt />
      </div>
      <div>
        <h4 className="csec-heading">Visit Us</h4>
        <p className="csec-description">
          # 8/8, 1st Cross, SSI Area,5th Block (Behind S.J.R School),<br /> Rajajinagar, Bangalore 560 010.</p>
      </div>
    </div>

    {/* Mail Us */}
    <div className="csec-item">
      <div className="csec-icon">
        <FaEnvelope />
      </div>
      <div>
        <h4 className="csec-heading">Mail Us</h4>
        <p className="csec-description">admin@sreenathji.com</p>
      </div>
    </div>

    {/* Call Us */}
    <div className="csec-item">
      <div className="csec-icon">
        <FaPhoneAlt />
      </div>
      <div>
        <h4 className="csec-heading">Call Us</h4>
        <p className="csec-description">
  <a href="tel:+919972601957" style={{ color: "inherit", textDecoration: "none" }}>
    +91-9972601957
  </a>
</p>
<p className="csec-description">
  <a href="tel:+919900105451" style={{ color: "inherit", textDecoration: "none" }}>
    +91-9900105451
  </a>
</p>
      </div>
    </div>
  </div>
</div>

    </section>
  );
}
